import React, {Component} from 'react'
import {connect} from 'react-redux'
import {compose} from 'recompose'
import VoiceTestCandidatesList from './candidates-content/VoiceTestCandidatesList'
import VoiceTestCandidateSearch from './candidates-content/VoiceTestCandidateSearch'
import ProtectedElement from '../common/helpers/ProtectedElement'
import {permissionByProfileType} from '../common/functions/permissions'

class VoiceTestCandidates extends Component {
  render() {
    if (this.props.overview === null) {
      return (<div />)
    }

    return (
      <div>
        <VoiceTestCandidatesList voiceTestId={this.props.voiceTestId} />
        <br /><br /><br />
        {(this.props.overview.Status === 'Draft' || this.props.overview.Status === 'Active') &&
          <ProtectedElement permission={permissionByProfileType(this.props.overview.ProfileType, 'Suggest')}>
            <VoiceTestCandidateSearch voiceTestId={this.props.voiceTestId} skillType={this.props.overview.SkillType}/>
          </ProtectedElement>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  overview: state.voiceTestPage.overview,
})
const mapDispatchToProps = dispatch => ({
})
export default compose(connect(mapStateToProps, mapDispatchToProps))(VoiceTestCandidates)
